import { API_ENDPOINTS } from '../../../constants/apiEndpoints';
import { ENVIRONMENT_CONFIG } from '../../../constants/environmentConfig';
import fetcher from '../../../helpers/fetcher';
import { unwrapDataResponse } from '../../../utils/unwrapDataResponse';

const unwrapListResponse = (response: any) => ({
  ...response,
  data: unwrapDataResponse<any>(response.data),
});

export const getPresentationList = async (filterParams: any) => {
  try {
    const response = await fetcher.get(
      API_ENDPOINTS.PRESENTATION.GET_PRESENTATION_LIST,
      filterParams,
      {},
      ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE
    );
    return unwrapListResponse(response);
  } catch (error: any) {
    throw error;
  }
};

export const getBasketList = async (filterParams: any) => {
  try {
    const response = await fetcher.get(
      API_ENDPOINTS.BASKET.GET_BASKET_LIST,
      filterParams,
      {},
      ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE
    );
    return unwrapListResponse(response);
  } catch (error: any) {
    throw error;
  }
};

export const getPoductCategoryList = async (filterParams: any) => {
  try {
    const response = await fetcher.get(
      API_ENDPOINTS.PRODUCT_CATEGORY.GET_PRODUCT_CATEGORY_LIST,
      filterParams,
      {},
      ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE
    );
    return unwrapListResponse(response);
  } catch (error: any) {
    throw error;
  }
};

export const downloadProductTemplate = async () => {
  try {
    const response = await fetcher.get(
      API_ENDPOINTS.PRESENTATION.DOWNLOAD_TEMPLATE,
      {},
      { responseType: 'blob' },
      ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const uploadProductBulk = async (uploadData: any) => {
  try {
    const response = await fetcher.post(
      API_ENDPOINTS.PRESENTATION.UPLOAD_BULK,
      uploadData,
      {},
      ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};
